import { call, put } from 'redux-saga/effects';

import { MESSAGES } from 'appconstants';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';

import {
  PUBLICKEYS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchPublickeys = async (payload) => {
  const query = '?page=1&size=100';
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.PUBLICKEYS}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.PUBLICKEYS}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.PUBLICKEYS}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.PUBLICKEYS}${query}${sorting}`);
};


const postPublickey = async ({ gid, params }) => axiosAuthInstance.post(`${API_END_POINTS.PUBLICKEYS}/${gid}/roll`, params);

export function* getPublickeys(action) {
  try {
    const { data: { entity } } = yield call(fetchPublickeys, action.payload);
    yield put({ type: PUBLICKEYS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: PUBLICKEYS.FAILED, payload: e.response.data });
    yield put({
      type: NOTIFICATION.ERROR,
      payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
    });
  }
}

export function* updatePublickey(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield call(postPublickey, action.payload);
    const { data: { entity } } = yield call(fetchPublickeys, action.payload);
    yield put({ type: PUBLICKEYS.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.PUBLICKEYS.UPDATE_SUCCESS,
    });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
